<template>
  				<div id="app" class="home-wrap" :class="exclusive_info==1?'bg1':'bg2'" v-cloak>
            <!-- 活动规则按钮 -->
            <div class="rule_btn" @click="show_dialog()" >
                <img src="../../assets/images/activity/1yuan365new/rule-btn.png" alt=""  >
            </div>
            <!-- 在线客服按钮 -->
            <div class="kefu_btn" v-show="customerShow">
                <img src="../../assets/images/activity/1yuan365new/tel-btn.png" alt="" @click="kefuBtn()" >
            </div>
			<!-- 新人专享 -->
			<div class="exclusive" v-if="exclusive_info==1" >
				<img src="../../assets/images/activity/1yuan365new/xinren-title.png" alt="" class="title-png" />
				<div class="exclusive-content">
					<div class="exclusive-content-wrap">
						<div class="content-wrap-left">
							<img src="../../assets/images/activity/1yuan365new/xinren-365.png" alt="" />
							<img src="../../assets/images/activity/1yuan365new/xinren-1.png" alt="" class="left-icon-top50" />
						</div>
						<div class="content-wrap-right">
							<el-tooltip
								class="item"
								effect="dark"
								content="手机号错误"
								placement="top-start"
								v-model="phone_err"
								:manual="true"
							>
								<el-input
									placeholder="请输入您的手机号码"
									class="right-mobile-input"
									v-model="mobile"
								>
									<i slot="prefix" class="right-icon-iphone"></i>
								</el-input>
							</el-tooltip>

							<div class="right-yzm-info">
								<!-- 验证码 -->
								<div class="right-yzm-input">
									<el-tooltip
										class="item"
										effect="dark"
										content="验证码错误"
										placement="top-start"
										v-model="code_err"
										:manual="true"
									>
										<el-input
											placeholder="请输入短信验证码"
											class="right-mobile-input"
											v-model="captcha"
										>
											<i slot="prefix" class="right-icon-yzm"></i>
										</el-input>
									</el-tooltip>
								</div>
								<!-- 发送按钮 -->
								<div class="right-yzm-button">
									<el-button type="danger" :class="yzm_button_switch?'right-yzm-button-gray':'right-yzm-button-info'" @click="sendCaptcha()" >{{send_code_btn_text}}</el-button>
								</div>
							</div>
							<!-- 购买按钮 -->
							<div class="right-gm-button">
								<el-button type="danger" class="right-gm-button-info" @click="buy()" >确认购买</el-button>
							</div>
							<!-- 阅读条款 -->
							<div class="right-read-info">
								<div class="read-left">
									<el-tooltip
										class="item"
										effect="dark"
										content="请确认协议"
										placement="bottom"
										v-model="agreement_err"
										:manual="true"
									>
										<i class="left-unchecked" v-if="!agreement_info" @click="checkButton()" ></i>
										<i class="left-checked" v-else @click="checkButton()" ></i>
									</el-tooltip>
								</div>
								<div class="read-right">
									阅读并同意
									<span>
                    <a href="https://i.dzh.com.cn/UserCenter/rulesregister.html">《使用软件许可协议》</a>
                  </span>
									中的各项条款 同意接受软件相关服务（短信&电话）
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <!-- 达人专享 -->
            <div class="daren_exclusive" v-if="exclusive_info==2" >
                <div class="exclusive-content">
                    <!-- 标题 -->
                    <div class="exclusive-content-title">
                        <img src="../../assets/images/activity/1yuan365new/daren-title.png" alt="" class="img-title" >
                    </div>
                    <!-- 价格 -->
                    <div class="exclusive-content-jiage" >
                        <img src="../../assets/images/activity/1yuan365new/daren-yue.png" alt="" class="img-jiage" >
                    </div>
                    <!-- 按钮 -->
                    <div class="exclusive-content-but">
                        <img src="../../assets/images/activity/1yuan365new/daren-but.png" alt="" class="daren-but" @click="buyDaren()" >
                    </div>
                    <!-- 协议 -->
                    <div class="exclusive-content-read">
                        <div class="daren-read">
                            <div class="read-left">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="请确认协议"
                                    placement="bottom"
                                    v-model="daren_agreement_err"
                                    :manual="true"
                                >
                                    <i class="left-unchecked" v-if="!daren_agreement_info" @click="checkButtonDaren()" ></i>
                                    <i class="left-checked" v-else @click="checkButtonDaren()" ></i>
                                </el-tooltip>
                            </div>
                            <div class="read-right">
                                <span class="read-right-text">
                                  <a href="https://i.dzh.com.cn/UserCenter/rulesregister.html">阅读并同意《使用软件许可协议》</a>
                                  </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<!-- 功能简介 -->
			<div class="mod">
				<div class="con">
					<img src="../../assets/images/activity/1yuan365new/title1.png" alt="" class="title" />
					<h2>
						<span>超级Level2</span>
					</h2>
					<p>千万股民口碑之选——千档行情、全息盘口，主力控盘区域一目了然</p>
					<img src="../../assets/images/activity/1yuan365new/img1.jpg" alt="" />
					<div class="info">
						<span>Level2超级盘口对于分析盘中买卖盘、盘后复盘有极其重要的作用。</span>
						<span>千档盘口让你看到别人看不到的行情，一眼看穿主力大资金潜伏价位；</span>
						<span>全息盘口完美展示个股每一笔的成交情况，是盘中跟踪、盘后复盘利</span>
					</div>
					<h2>
						<span>波段线</span>
					</h2>
					<div class="summary">
						<span>
							<strong>L</strong>
							点：关注信号
						</span>
						<span>
							<strong>B</strong>
							点：反转信号
						</span>
						<span>
							<strong>D</strong>
							点：风险信号
						</span>
						<span>
							<strong>S</strong>
							点：避险信号
						</span>
					</div>
					<img src="../../assets/images/activity/1yuan365new/img2.jpg" alt="" />
					<h2 class="mt">
						<span>热钱追踪</span>
					</h2>
					<p>DDE当日资金流排序功能，助力投资者紧跟热钱的脚步</p>
					<img src="../../assets/images/activity/1yuan365new/img3.jpg" alt="" />
				</div>
			</div>
			<img src="../../assets/images/activity/1yuan365new/title2.jpg" alt="" class="img-auto" />
			<!-- 底部 -->
			<div class="bottom-info">
				<div class="bottom-text">
					<div class="bottom-info-felx">
						<div class="bottom-text-felx">
							<img src="../../assets/images/activity/1yuan365new/icon-tel.png" alt="" class="bottom-text-icon" />
							<span class="bottom-text-top">免费服务热线: 021-20219997</span>
						</div>
						<div class="bottom-text-felx">
							<img src="../../assets/images/activity/1yuan365new/icon-time.png" alt="" class="bottom-text-icon" />
							<span class="bottom-text-top">周一至周五 8:30-17:30</span>
						</div>
					</div>

					<div class="bottom-text-info">
						风险提示:
						本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议，数据基于历史，不代表未来趋势，所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。
					</div>
				</div>
			</div>

            <!-- 规则弹窗 -->
            <div class="dialog_info" v-show="dialog_switch" @click="dialog_switch = false" >
                <div class="dialog_info_content" @click.stop="show_dialog()" >
                    <!-- 标题 -->
                    <div class="info_content_title">
                        <img src="../../assets/images/activity/1yuan365new/dialog-title.png" alt="">
                    </div>
                    <!-- 内容 -->
                    <div class="info_content_text">
                        <span>1、活动时间：2024年1月1日-2024年12月31日</span>
                        <span>2、活动期间，符合条件的用户可以1元购买大智慧365版本30天的使用权。</span>
                        <span>3、每位符合条件的用户，仅有一次机会，1元体验大智慧365。</span>
                        <span>4、此活动归属权归大智慧所有。</span>
                        <span>5、活动期间，凡以不正当手段（如恶意刷单、作弊、扰乱系统、实施网络攻击等）参与本次活动的用户，大智慧有权终止其参与活动并回收所有产品体验权；如遇不可抗力（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整、活动中存在大面积作弊行为、活动遭遇严重网络攻击或系统故障导致活动不能正常进行）的影响，大智慧保留在法律规定范围内对上述规则进行解释的权利。</span>
                        <span>6、关于活动任何问题，可在工作日8:30-17:30通过以下方式联系客服：</span>
                        <span>全国统一服务热线：021-20219997。</span>
                    </div>
                </div>
            </div>

            <!-- 支付弹窗 -->
            <div class="dialog_zhifu" v-show="dialog_zhifu_switch" >
                <div class="dialog_info_content">
                    <img src="../../assets/images/activity/1yuan365new/dialog-off.png" alt="" class="dialog-off" @click="off_zhifu_dialog()" >
                    <div class="content_felx">
                        <div class="content_felx_left">
                            <div class="felx_left_title">炒股达人专享价</div>
                            <div class="felx_left_text">大智慧365年卡订阅</div>
                            <div class="felx_left_jiage">
                                <span class="left_jiage_rmb">¥</span>
                                <span class="left_jiage_num">998</span>
                                <span class="left_jiage_text">/年</span>
                            </div>
                            <div class="felx_left_account">开通账户: {{this.userName}}</div>
                        </div>
                        <div class="content_felx_right">
                            <!-- 扫码 -->
                            <div v-if="saoma_info==1" >
                                <div class="right_saoma_jine">应付金额: <span class="saoma_jine_num">998</span>元</div>
                                <div class="right_saoma_info">
                                    <div class="right_saoma_code">
                                        <div class="code_qr"></div>
                                        <div class="code_text"> <i class="saoma-vx"></i> 微信支付</div>
                                    </div>
                                    <div class="right_saoma_code">
                                        <div class="code_qr"></div>
                                        <div class="code_text"><i class="saoma-zfb"></i>支付宝支付</div>
                                    </div>
                                </div>
                            </div>
                            <!-- 支付中 -->
                            <div v-if="saoma_info==2">
                                <div class="right_saoma_zfz">正在支付...</div>
                            </div>
                            <!-- 支付成功 -->
                            <div v-if="saoma_info == 3">
                                <div class="right_saoma_success">
                                    <div class="success_img">
                                        <img src="../../assets/images/activity/1yuan365new/saoma-success.png" alt="">
                                    </div>
                                    <div class="success_text">付款成功</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

		</div>
</template>

<script>

export default {
  data: function() {
    return {
      mobile: '', // 手机号
			captcha: '', // 验证码
      agreement_info:false, // 协议按钮
      daren_agreement_info:false, // 达人协议按钮
			phone_err: false, //手机的错误开关
			code_err: false, // 验证码错误开关
			agreement_err: false, // 协议错误开关
      daren_agreement_err:false, // 达人协议错误开关
      yzm_button_switch:false, // 灰色按钮开关
      send_code_btn_text:'获取验证码',
      dialog_switch:false, // 弹窗开关
      dialog_zhifu_switch:false, // 支付弹窗开关
      exclusive_info:1, // 1-新人专享 2-达人专享
      saoma_info:1,  // 1-扫码 2-支付中 3-支付成功
      payloadParams: { productId: 116, month: 1 },
      userName: "",
      ConvID: this.$route.query.ConvID, // 
      customerShow: false,
      s: this.$route.query.s
    };
  },
  created() {
    var index = window.location.href.indexOf("?");
    if (index > -1) {
      this.queryParams = window.location.href.substring(index);
    }
    if(this.ConvID){
      this.customerShow = true;
    }
    if(!this.s){
      this.s = "";
    }
  },
  mounted(){
    this.onload()
  },
  methods: {
    onload(){
      var vars =  document.getElementsByClassName('el-input__inner')
    debugger
    for(let index = 0; index < vars.length; index++) {
      var element = vars[index];
      element.style.height='56px';
      element.style.paddingLeft = '65px';
      element.style.fontSize ='20px';
      element.style.color ='#d4d4d4';
    }
    },                
   checkButtonDaren(){// 点击勾选达人协议
      this.daren_agreement_info = !this.daren_agreement_info;
    },
    checkButton(){
      this.agreement_info = !this.agreement_info;
    },
    checkPrams(){
      if (!this.mobile || !this.$validate.checkPhone(this.mobile)) {
        this.show_err(1)
        return false;
      }
      debugger
      var prefix = this.mobile.substring(0,3);
      if (prefix == "170" || prefix == "171" || prefix == "165") {
        alert("虚拟号码不可参与购买")
        return false;
      }
      return true;
    },
    sendCaptcha(){

      // 如果为灰色按钮，则不执行
      if(this.yzm_button_switch){
        return false;
      }
      if(!this.checkPrams()){
        return false;
      }
      if (!this.agreement_info) {
        this.show_err(3);
        return false;
      }
      var params = {
        mobile: this.mobile
      }
      this.$post("/activity/captcha", params)
        .then(response => {
          if (response.code === 0) {
            this.$global.alert("验证码发送成功");
            this.count_down(60);
          } else{
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    // 设置倒计时
    count_down:function(){
      var that = this;
      var count = 60;
      var timer = setInterval(function(){
      count--;
      if(count == 0){
        clearInterval(timer);
        that.send_code_btn_text = "发送验证码";
        that.yzm_button_switch = false;
      } else{
        that.send_code_btn_text = count + "S";
        that.yzm_button_switch = true;
      }
      },1000);
    },
    buyDaren(){
      if (!this.daren_agreement_info) {
        this.show_err(4);
        return false;
      }
      this.$router.push("/order/confirm/116/12?s=" + this.s);
    },
    buy() {
      if(!this.checkPrams()){
        return false;
      }
      if (!this.agreement_info) {
        this.show_err(3);
        return false;
      }
      if(this.captcha == ""){
        this.show_err(2);
        return false;
      }
      this.payloadParams.mobile = this.mobile;
      this.payloadParams.captcha = this.captcha;
      this.$post("/activity/oybInit" + this.queryParams, this.payloadParams)
        .then(response => {
          debugger
          if (response.code === 0) {
            this.$storage.saveUserName(response.data);
            this.userName = response.data;
            this.$router.push("/order/confirm/116/1dzhpfo?s=" + this.s);
          } else if (response.code === 203) {
            this.$storage.saveUserName(response.data.userName);
            this.userName = response.data;
            this.$global.alert(response.msg);
            this.exclusive_info = 2
          }else if (response.code === 1001) {
            this.$storage.saveUserName(response.data.userName);
            this.$router.push("/order/pay/" + response.data.id);
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    show_err:function(err){
      var that = this;
      if(err == 1) {
        that.phone_err = true;
         setTimeout(function(){
             that.phone_err = false;
         },2000);
        } else if(err == 2) {
          that.code_err = true;
          setTimeout(function(){
          that.code_err = false;
        },2000);
      } else if(err == 3) {
          that.agreement_err = true;
          setTimeout(function(){
            that.agreement_err = false;
          },2000);
      } else if(err == 4) {
        that.daren_agreement_err = true;
        setTimeout(function(){
          that.daren_agreement_err = false;
        },2000);
      }
    },
    // 点击活动规则
    show_dialog(){
      var that = this;
      that.dialog_switch = true;
    },
    scroll() {
      window.scrollTo(0, 400);
    },
    kefuBtn() {
      window.external.addcommand('cmd?GWCHAT&TYPE=OPENINNERCONVERSATION&CONVTYPE=Single&CONVID=' + this.ConvID)
    },
  }
};
</script>

<style lang="scss" scoped>
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
em,
strong,
th,
td,
textarea,
button,
input,
select,
figure,
figcaption {
  padding: 0;
  margin: 0;
  font-style: normal;
  font-weight: normal;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

body {
  font-family: PingFangSC-Regular, Helvetica, Tahoma, Arial, 'Microsoft YaHei', 'Hiragino Sans GB',
 'WenQuanYi Micro Hei', sans-serif;
}

textarea,
button,
input,
select {
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  border: 0;
}

li,
dd {
  list-style: none;
}

a {
  text-decoration: none;
}

table {
  border-collapse: collapse;
}

img {
  border: 0;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: ' ';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

[v-cloak] {
  display: none !important;
}

.font-red {
  color: #ef3939 !important;
}

.font-green {
  color: #1eac4e !important;
}

/* PC */
html,
body {
  height: 100%;
  background: #fff;
}

/* app */
.bg1 {
  background: url(../../assets/images/activity/1yuan365new/bg1.jpg) #feeddb no-repeat center top;
}

.bg2 {
  background: url(../../assets/images/activity/1yuan365new/bg2.png) #feeddb no-repeat center top;
}

.home-wrap {
  padding-top: 545px;
  position: relative;
}

.home-wrap .rule_btn {
  display: inline-block;
  position: absolute;
  top: 70px;
  right: 0;
  cursor: pointer;
}

.home-wrap .rule_btn img {
  width: 58px;
  height: 160px;
}

.home-wrap .kefu_btn {
  display: inline-block;
  position: absolute;
  bottom: 350px;
  right: 0;
  cursor: pointer;
}

.home-wrap .kefu_btn img {
  width: 140px;
  height: 100px;
}

.home-wrap .exclusive {
  width: 900px;
  height: 448px;
  margin: 0 auto;
  margin-bottom: 80px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px #e4a06e;
  padding: 10px;
  position: relative;
}

.home-wrap .exclusive .title-png {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -25px;
}

.home-wrap .exclusive .exclusive-content {
  background-image: url("../../assets/images/activity/1yuan365new/xinren-bg.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: inline-block;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap {
  width: 100%;
  height: 308px;
  display: inline-block;
  margin-top: 100px;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-left {
  width: 30%;
  height: 100%;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-left .left-icon-top50 {
  margin-top: 50px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right {
  width: 60%;
  height: 100%;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-icon-iphone {
  width: 25px;
  height: 27px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-tel-icon.png");
  background-size: 100% 100%;
  margin: 0 20px;
  margin-top: calc(50% - 18px);
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-mobile-input .el-input__inner {
  height: 56px;
  padding-left: 65px;
  font-size: 20px;
  color: #d4d4d4;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-yzm-info {
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-yzm-info .right-yzm-input {
  width: 320px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-yzm-info .right-icon-yzm {
  width: 25px;
  height: 27px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-dx-icon.png");
  background-size: 100% 100%;
  margin: 0 20px;
  margin-top: calc(50% - 18px);
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-yzm-info .right-yzm-button .right-yzm-button-info {
  width: 150px;
  height: 56px;
  font-size: 19px;
  background-image: linear-gradient(to right, #e7382c, #f7866e);
  border-radius: 1px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-yzm-info .right-yzm-button .right-yzm-button-gray {
  width: 150px;
  height: 56px;
  font-size: 19px;
  background-image: linear-gradient(to right, #999999, #999999);
  border: 1px solid #999999;
  border-radius: 1px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-gm-button {
  width: 100%;
  height: 56px;
  margin-top: 30px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-gm-button .right-gm-button-info {
  width: 100%;
  height: 100%;
  font-size: 22px;
  background-image: linear-gradient(to right, #e7382c, #f7866e);
  border-radius: 1px;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-read-info {
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-read-info .read-left {
  width: 30px;
  height: auto;
  display: inline-block;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-read-info .read-left .left-unchecked {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-wgx-icon.png");
  background-size: 100% 100%;
  margin-top: 2px;
  cursor: pointer;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-read-info .read-left .left-checked {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-gx-icon.png");
  background-size: 100% 100%;
  margin-top: 2px;
  cursor: pointer;
}

.home-wrap .exclusive .exclusive-content .exclusive-content-wrap .content-wrap-right .right-read-info .read-right {
  font-size: 14px;
}

.home-wrap .daren_exclusive {
  width: 900px;
  height: 448px;
  margin: 0 auto;
  margin-bottom: 80px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px #e4a06e;
  padding: 10px;
}

.home-wrap .daren_exclusive .exclusive-content {
  background-image: url("../../assets/images/activity/1yuan365new/daren-bg.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: inline-block;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-title {
  margin-top: 60px;
  width: 100%;
  height: 60px;
  text-align: center;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-title .img-title {
  height: 60px;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-jiage {
  margin-top: 30px;
  width: 100%;
  height: 44px;
  text-align: center;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-jiage .img-jiage {
  height: 44px;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-but {
  margin-top: 45px;
  width: 100%;
  height: 84px;
  text-align: center;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-but .daren-but {
  height: 84px;
  cursor: pointer;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-read {
  margin-top: 25px;
  width: 100%;
  text-align: center;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-read .daren-read {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-read .read-right-text {
  margin-left: 10px;
  color: #7797ff;
  cursor: pointer;
  font-size: 16px;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-read .left-unchecked {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-wgx-icon.png");
  background-size: 100% 100%;
  margin-top: 2px;
  cursor: pointer;
}

.home-wrap .daren_exclusive .exclusive-content .exclusive-content-read .left-checked {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/images/activity/1yuan365new/xinren-gx-icon.png");
  background-size: 100% 100%;
  margin-top: 2px;
  cursor: pointer;
}

.home-wrap .mod {
  background: #ffeacf;
  border: 1px solid #fff;
  box-shadow: 0 0 10px #e4a06e;
  width: 900px;
  margin: 0 auto;
  padding: 15px;
  border-radius: 20px;
}

.home-wrap .mod .con {
  background: #fff;
  box-shadow: 0 0 10px #e4a06e;
  padding: 90px 30px 40px;
  border-radius: 14px;
  position: relative;
}

.home-wrap .mod .con .title {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -40px;
}

.home-wrap .mod .con h2 {
  font-size: 36px;
  color: #442a13;
}

.home-wrap .mod .con h2.mt {
  margin-top: 60px;
}

.home-wrap .mod .con h2 span {
  position: relative;
  line-height: 1;
  z-index: 1;
  font-weight: bold;
}

.home-wrap .mod .con h2 span:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 110%;
  height: 11px;
  background: #fcecd3;
  z-index: -1;
}

.home-wrap .mod .con p {
  font-size: 30px;
  color: #442a13;
  margin: 20px 0;
}

.home-wrap .mod .con .info {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 70px;
}

.home-wrap .mod .con .info span {
  width: 234px;
  padding: 30px 22px;
  line-height: 44px;
  font-size: 26px;
  color: #432813;
  background-image: linear-gradient(135deg, #fdf1de, #fddaaa);
  border-radius: 70px 20px 70px 20px;
}

.home-wrap .mod .con .summary {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}

.home-wrap .mod .con .summary span {
  width: 33.3%;
  margin-bottom: 25px;
  font-size: 30px;
  color: #442a13;
  line-height: 1;
  display: flex;
  align-items: center;
}

.home-wrap .mod .con .summary span:before {
  content: '';
  display: inline-block;
  background: #818281;
  width: 17px;
  height: 17px;
  margin-right: 15px;
  vertical-align: middle;
}

.home-wrap .mod .con .summary span:nth-child(2):before {
  background: #ffb65e;
}

.home-wrap .mod .con .summary span:nth-child(3):before {
  background: #50fbff;
}

.home-wrap .mod .con .summary span:nth-child(4):before {
  background: #50ff6a;
}

.home-wrap .mod .con .summary span strong {
  font-weight: bold;
}

.home-wrap .img-auto {
  display: block;
  margin: 50px auto 0;
}

.home-wrap .bottom-info {
  height: 220px;
  width: 100%;
  background-color: #fed39e;
  display: inline-block;
}

.home-wrap .bottom-text {
  width: 900px;
  margin: 30px auto;
  text-align: center;
}

.home-wrap .bottom-text .margin-top30 {
  margin-top: 30px;
}

.home-wrap .bottom-text .bottom-info-felx {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.home-wrap .bottom-text .bottom-text-felx {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.home-wrap .bottom-text .bottom-text-icon {
  width: 25px;
  height: 25px;
}

.home-wrap .bottom-text .bottom-text-top {
  font-size: 22px;
  font-weight: 900;
  color: #5b3c1e;
  margin-left: 8px;
}

.home-wrap .bottom-text .bottom-text-info {
  text-align: left;
  font-size: 19px;
  font-weight: normal;
  margin-top: 30px;
  color: #bb966c;
}

.home-wrap .dialog_info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
}

.home-wrap .dialog_info .dialog_info_content {
  width: 80%;
  height: 600px;
  position: sticky;
  top: 150px;
  left: 10%;
  border-radius: 10px;
  background-image: url("../../assets/images/activity/1yuan365new/dialog-bg.png");
  background-size: 100% 100%;
}

.home-wrap .dialog_info .dialog_info_content .info_content_title {
  width: 100%;
  height: 80px;
  text-align: center;
}

.home-wrap .dialog_info .dialog_info_content .info_content_text {
  width: 100%;
  height: 520px;
  padding: 40px 60px;
}

.home-wrap .dialog_info .dialog_info_content .info_content_text span {
  width: 100%;
  display: block;
  color: #a9690f;
  font-size: 20px;
  line-height: 40px;
}

.home-wrap .dialog_zhifu {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
}

.home-wrap .dialog_zhifu .dialog_info_content {
  width: 80%;
  min-width: 900px;
  height: 490px;
  position: sticky;
  top: 150px;
  left: 10%;
  border-radius: 15px;
  background-color: #ffffff;
  padding: 70px 95px;
}

.home-wrap .dialog_zhifu .dialog_info_content .dialog-off {
  width: 44px;
  height: 44px;
  position: absolute;
  top: -50px;
  right: 0px;
  cursor: pointer;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left {
  width: 40%;
  height: 340px;
  border: 1px solid #ffcd87;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_title {
  width: 210px;
  height: 44px;
  border-radius: 15px;
  background-color: #ff2423;
  line-height: 44px;
  text-align: center;
  font-size: 24px;
  color: #ffffff;
  font-weight: bold;
  margin-top: -22px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_text {
  margin-top: 65px;
  font-weight: 500;
  font-size: 28px;
  color: #666;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_jiage {
  margin-top: 30px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_jiage .left_jiage_rmb {
  color: #666666;
  font-size: 22px;
  font-weight: bold;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_jiage .left_jiage_num {
  color: #a9690f;
  font-size: 56px;
  font-weight: bold;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_jiage .left_jiage_text {
  color: #ff0000;
  font-size: 22px;
  font-weight: bold;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_left .felx_left_account {
  margin-top: 30px;
  color: #7fb4e6;
  font-size: 16px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right {
  width: 55%;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_jine {
  text-align: center;
  font-weight: 500;
  color: #9f9f9f;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_jine .saoma_jine_num {
  font-weight: bold;
  color: #d3a672;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_info {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  margin-top: 40px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_info .right_saoma_code .code_qr {
  width: 162px;
  height: 162px;
  border: 1px solid;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_info .right_saoma_code .code_text {
  margin-top: 20px;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_info .right_saoma_code .saoma-vx {
  width: 25px;
  height: 23px;
  display: inline-block;
  margin-right: 10px;
  background-image: url("../../assets/images/activity/1yuan365new/saoma-vx.png");
  background-size: 100% 100%;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_info .right_saoma_code .saoma-zfb {
  width: 25px;
  height: 25px;
  display: inline-block;
  margin-right: 10px;
  background-image: url("../../assets/images/activity/1yuan365new/saoma-zfb.png");
  background-size: 100% 100%;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_zfz {
  text-align: center;
  font-size: 30px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_success {
  text-align: center;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_success .success_img img {
  width: 80px;
  height: 80px;
}

.home-wrap .dialog_zhifu .dialog_info_content .content_felx .content_felx_right .right_saoma_success .success_text {
  margin-top: 30px;
  font-size: 24px;
}


</style>


// WEBPACK FOOTER //
// src/pages/activity/OYB116new.vue